import React, { useEffect } from 'react';
import Hero from './components/Hero';
import TransitionSection from './components/TransitionSection';
import WhyMatters from './components/WhyMatters';
import Experience from './components/Experience';
import LastMinute from './components/LastMinute';
import Editorial from './components/Editorial';
import InquiryForm from './components/InquiryForm';
import FooterCTA from './components/FooterCTA';

/**
 * Padua Weddings - October 17 Availability 
 * All metadata is statically defined in index.html for maximum SEO compatibility.
 */
function App() {
  useEffect(() => {
    // Force title update on load to prevent any framework overrides
    document.title = "Padua Weddings | October 17 Wedding Date Available";

    const handleAnchorClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
        e.preventDefault();
        const targetId = anchor.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div className="min-h-screen bg-charcoal selection:bg-gold/30 selection:text-ivory font-sans relative overflow-x-hidden">
      <Hero />
      <TransitionSection />
      <WhyMatters />
      <Experience />
      <LastMinute />
      <Editorial />
      <InquiryForm />
      <FooterCTA />
    </div>
  );
}

export default App;